import { DigitCounter } from "./DigitCounter/DigitCounter";

export class DigitCounterComponent {
  constructor(container) {
    if (!container) {
      throw new Error('Container element is required');
    }

    this.container = container;
    this.elements = this.container.querySelectorAll('[data-digit-counter]');
    this.components = [];

    if (this.elements.length > 0) {
      this.init();
    }
  }

  init() {
    this.elements.forEach(element => {
      const counter = new DigitCounter(element);
      this.components.push(counter);
    })
  }

  dispose() {
    if(this.components.length) {
      this.components.forEach(component => {
        component.dispose();
      })
    }

    this.components = null;
    this.elements = null;
    this.container = null;
  }
}
